import React from "react";
import editIcon from "../assets/images/icons/edit.svg";
import deleteIcon from "../assets/images/icons/trash.svg";
import downlaodIcon from "../assets/images/icons/download.svg";


const ActionButtons = ({ onEdit, onDelete, onDownload, rowData, showDelete, editBtnIcon = editIcon, additonalBtn = false}) => (
  <div>
    <button
      onClick={() => onEdit(rowData)}
      title="Edit"
      className="btn btn-outline-secondary btn-sm"
      style={{ padding: "5px" }}
    >
      <img 
        src={editBtnIcon} 
        alt="Edit" 
        style={{ width: "20px", height: "20px" }} 
      />
    </button>
    { additonalBtn && <button
      onClick={() => onDownload(rowData)}
      title="Download"
      className="btn btn-outline-secondary btn-sm"
      style={{ marginLeft: "5px", padding: "5px" }}
    >
      <img 
        src={downlaodIcon} 
        alt="Delete" 
        style={{ width: "20px", height: "20px" }} 
      />
    </button> }
    {showDelete && <button
      onClick={() => onDelete(rowData)}
      className="btn btn-outline-secondary btn-sm"
      title="Delete"
      style={{ marginLeft: "5px", padding: "5px" }}
    >
      <img 
        src={deleteIcon} 
        alt="Delete" 
        style={{ width: "20px", height: "20px" }} 
      />
    </button> }
  </div>
);

export default ActionButtons;
